import { calculatePaginationOffset, convertSortToQueryString, } from "@sscs/utils";
import { REPORTS_ENDPOINT } from "../../constants";
import { baseApi } from "./base.api.required.stub";
const policiesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getPolicies: build.query({
            query: (data) => ({
                url: `${REPORTS_ENDPOINT}/${data.ui_id}/policies`,
                params: {
                    diff_report_id: data.diff_report_id,
                    policy_category: data.filter.policy_category,
                    assessment_category: data.filter.assessment_category,
                    policy_state: data.filter.policy_state,
                    is_audit_present_only: data.filter.is_audit_present_only,
                    limit: data.pagination.itemsPerPage,
                    offset: calculatePaginationOffset(data.pagination),
                    sort_by: convertSortToQueryString(data.sort),
                },
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetPoliciesQuery } = policiesApi;
//# sourceMappingURL=policies.api.js.map